<template>
<div class="row">
    <loader :visible="true" v-if="!componentReady"></loader>
  <div class="col-12 col-lg-4 bg-gray no-padding">
    <div class="event">
      <div class="event-header">
        <img class="bg-thumb" alt="Veranstaltungsbild" :src="eventInfo.imageUrl" />
        <div class="event-header-inner">
          <h1>{{eventInfo.title}}</h1>
          <h3>{{eventInfo.subtitle}}</h3>
        </div>
      </div>
      <div class="event-body d-none d-sm-block">
        <p v-html="eventInfo.description">
        </p>

        <div class="row">

          <div class="col-2 text-center" style="font-size:25pt;">
            <font-awesome-icon icon="calendar" />
          </div>
          <div class="col-10">Veranstaltungsdatum<br/><b>{{eventDateTime}}</b></div>

        </div>

        <br/>

        <div class="row">

          <div class="col-2 text-center" style="font-size:25pt;">
            <font-awesome-icon icon="map-marker" />
          </div>
          <div class="col-10">Veranstaltungsort<br/><b>{{eventInfo.location}}</b></div>

        </div>

      </div>

      <div class="row">
        <div class="offset-md-3 col-md-6">
          <a class="btn btn-block btn-primary" href="https://tma-bensberg.de"><font-awesome-icon icon="ban"/> Buchung abbrechen</a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-8 enrollment">
    <div class="row enrollment-header">
      <div class="col-md-9">
        <h1>Ihre Anmeldung</h1> In vier einfachen Schritten zu Ihrer Buchung.<br/> Bitte füllen Sie dazu die folgenden Formulare aus:

      </div>
      <div class="col-md-3">
        <img src="https://tma-bensberg.de/wp-content/uploads/2015/10/tma-logo.png" class="logo" alt="TMA Logo"/>
      </div>
    </div>
    <div class="row enrollment-body">
      <div class="col-md-12">
        <form-wizard :start-index="formWizardStartStep" shape="tab" color="#0091D1" @on-validate="handleValidation" @on-change="onTabChange" back-button-text="Zum vorigen Schritt" next-button-text="Zum nächsten Schritt">
          <div slot="title"></div>
          <tab-content title="Buchungsinformationen" :before-change="validateEnrollmentInfo">
            <form class="enrollment-form">
              <fieldset name="participant-data">

                <div class="row">
                  <div class="col-12 col-md-8">

                    <div class="row" v-if="isEventDateAfterSept23">
                      <div class="col-12">
                        <div class="alert border-danger" style="border-style: double !important; border-width: 2px;">
                          <h5 class="text-danger">Wichtige Hinweise</h5>
                          Ausführliche Informationen finden Sie auf unserer Seite „<a href="https://tma-bensberg.de/allgemeine-hinweise/" target="_blank">Allgemeine Hinweise</a>“.<ul>
                          <li>Bitte melden Sie sich per E-Mail an, wenn Sie zum ersten Mal eine Veranstaltung der Thomas-Morus-Akademie Bensberg buchen, einen Gutschein einlösen oder eine Ermäßigung in Anspruch nehmen möchten, zum Beispiel als kirchlich engagierte oder ehrenamtlich tätige Person.</li>
                          <li>Bei einer Buchung über unseren Online-Shop wird Ihre Anmeldung unmittelbar verbindlich abgeschlossen. Nachträgliche Änderungen, etwa an der Rechnungsadresse oder die Berücksichtigung von Rabatten, sind daher leider nicht möglich.</li>
                        </ul>
                          E-Mail für Anmeldungen: <a href="mailto:akademie@tma-bensberg.de">akademie@tma-bensberg.de</a>
                        </div>
                      </div>
                    </div>

                    <!--
                    <div class="row" v-if="hasDiscounts">
                      <div class="col-12">
                        <div class="alert border-danger" style="border-style: double !important; border-width: 2px;">
                          Wenn Sie einen reduzierten Preis (Studierende, kirchlich engagierte Ehrenamtliche) in Anspruch nehmen oder einen Gutschein einlösen möchten, erfolgt die Anmeldung mit Nachweis <b>ausschließlich per E-Mail</b> an <a href="mailto:akademie@tma-bensberg.de">akademie@tma-bensberg.de</a><br/>Bereits getätigte Anmeldungen können nicht im Nachhinein rabattiert werden.
                        </div>
                      </div>
                    </div>
                    -->

                    <div class="alert alert-danger" v-if="$v.customer.$error">Bitte überprüfen Sie die rot markierten Felder, vielen Dank!</div>

                    <div class="row">
                      <div class="form-group col-12 col-md-6" >
                        <label for="inputAnrede" v-bind:class="{ 'label-error': $v.customer.salutation.$error }">Anrede</label>
                        <select class="form-control" id="inputAnrede" v-bind:class="{ 'is-invalid': $v.customer.salutation.$error }" v-model="customer.salutation" @change="onBlur">
                          <option :value="undefined" disabled>-- Keine Anrede --</option>
                          <option v-for="salutation in eventInfo.salutations" :value="salutation.Code">
                            {{salutation.Description}}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-12 col-md-6">
                        <label for="inputJob" v-bind:class="{ 'label-error': $v.customer.job.$error }">Titel</label>
                        <select class="form-control" id="inputJob" v-bind:class="{ 'is-invalid': $v.customer.job.$error }" v-model="customer.job" @change="onBlur">
                          <option :value="undefined" disabled>-- Kein Titel --</option>
                          <option v-for="job in eventInfo.jobs" :value="job.Code">
                            {{job.Code}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 col-md-6" >
                        <label for="inputVorname" v-bind:class="{ 'label-error': $v.customer.firstname.$error }">Vorname *</label>
                        <input class="form-control" id="inputVorname" placeholder="Vorname" v-bind:class="{ 'is-invalid': $v.customer.firstname.$error }" v-model="customer.firstname">
                      </div>
                      <div class="form-group col-12 col-md-6">
                        <label for="inputNachname" v-bind:class="{ 'label-error': $v.customer.lastname.$error }">Nachname *</label>
                        <input class="form-control" id="inputNachname" placeholder="Nachname" v-bind:class="{ 'is-invalid': $v.customer.lastname.$error }" v-model="customer.lastname">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 col-md-12">
                        <label for="inputStrasse" v-bind:class="{ 'label-error': $v.customer.street.$error }">Straße und Hausnummer *</label>
                        <input class="form-control" id="inputStrasse" placeholder="Straße und Hausnummer" v-bind:class="{ 'is-invalid': $v.customer.street.$error }" v-model="customer.street">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 col-md-4">
                        <label for="inputPLZ" v-bind:class="{ 'label-error': $v.customer.postalcode.$error }">Postleitzahl *</label>
                        <input class="form-control" id="inputPLZ" placeholder="PLZ" v-bind:class="{ 'is-invalid': $v.customer.postalcode.$error }" v-model="customer.postalcode">
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label for="inputOrt" v-bind:class="{ 'label-error': $v.customer.city.$error }">Ort *</label>
                        <input class="form-control" id="inputOrt" placeholder="Ort" v-bind:class="{ 'is-invalid': $v.customer.city.$error }" v-model="customer.city">
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label for="inputLand" v-bind:class="{ 'label-error': $v.customer.country.$error }">Land *</label>
                        <select class="form-control" id="inputLand" v-bind:class="{ 'is-invalid': $v.customer.country.$error }" v-model="customer.country">
                          <option value="DE" selected>Deutschland</option>
                          <option value="AT">Österreich</option>
                          <option value="CH">Schweiz</option>
                          <optgroup label="A">
                            <option value="AF">Afghanistan</option>
                            <option value="EG">Ägypten</option>
                            <option value="AX">Åland</option>
                            <option value="AL">Albanien</option>
                            <option value="DZ">Algerien</option>
                            <option value="AS">Amerikanisch-Samoa</option>
                            <option value="VI">Amerikanische Jungferninseln</option>
                            <option value="AD">Andorra</option>
                            <option value="AO">Angola</option>
                            <option value="AI">Anguilla</option>
                            <option value="AQ">Antarktis</option>
                            <option value="AG">Antigua und Barbuda</option>
                            <option value="GQ">Äquatorialguinea</option>
                            <option value="AR">Argentinien</option>
                            <option value="AM">Armenien</option>
                            <option value="AW">Aruba</option>
                            <option value="AC">Ascension</option>
                            <option value="AZ">Aserbaidschan</option>
                            <option value="ET">Äthiopien</option>
                            <option value="AU">Australien</option>
                          </optgroup>
                          <optgroup label="B">
                            <option value="BS">Bahamas</option>
                            <option value="BH">Bahrain</option>
                            <option value="BD">Bangladesch</option>
                            <option value="BB">Barbados</option>
                            <option value="BY">Belarus (Weißrussland)</option>
                            <option value="BE">Belgien</option>
                            <option value="BZ">Belize</option>
                            <option value="BJ">Benin</option>
                            <option value="BM">Bermuda</option>
                            <option value="BT">Bhutan</option>
                            <option value="BO">Bolivien</option>
                            <option value="BA">Bosnien und Herzegowina</option>
                            <option value="BW">Botswana</option>
                            <option value="BV">Bouvetinsel</option>
                            <option value="BR">Brasilien</option>
                            <option value="VG">Britische Jungferninseln</option>
                            <option value="IO">Britisches Territorium im Indischen Ozean</option>
                            <option value="BN">Brunei Darussalam</option>
                            <option value="BG">Bulgarien</option>
                            <option value="BF">Burkina Faso</option>
                            <option value="BI">Burundi</option>
                          </optgroup>
                          <optgroup label="C">
                            <option value="EA">Ceuta, Melilla</option>
                            <option value="CL">Chile</option>
                            <option value="CN">Volksrepublik China</option>
                            <option value="CP">Clipperton</option>
                            <option value="CK">Cookinseln</option>
                            <option value="CR">Costa Rica</option>
                            <option value="CI">Côte d'Ivoire (Elfenbeinküste)</option>
                          </optgroup>
                          <optgroup label="D">
                            <option value="DK">Dänemark</option>
                            <option value="DE">Deutschland</option>
                            <option value="DG">Diego Garcia</option>
                            <option value="DM">Dominica</option>
                            <option value="DO">Dominikanische Republik</option>
                            <option value="DJ">Dschibuti</option>
                          </optgroup>
                          <optgroup label="E">
                            <option value="EC">Ecuador</option>
                            <option value="SV">El Salvador</option>
                            <option value="ER">Eritrea</option>
                            <option value="EE">Estland</option>
                          </optgroup>
                          <optgroup label="F">
                            <option value="FK">Falklandinseln</option>
                            <option value="FO">Färöer</option>
                            <option value="FJ">Fidschi</option>
                            <option value="FI">Finnland</option>
                            <option value="FR">Frankreich</option>
                            <option value="GF">Französisch-Guayana</option>
                            <option value="PF">Französisch-Polynesien</option>
                          </optgroup>
                          <optgroup label="G">
                            <option value="GA">Gabun</option>
                            <option value="GM">Gambia</option>
                            <option value="GE">Georgien</option>
                            <option value="GH">Ghana</option>
                            <option value="GI">Gibraltar</option>
                            <option value="GD">Grenada</option>
                            <option value="GR">Griechenland</option>
                            <option value="GL">Grönland</option>
                            <option value="GB">Großbritannien</option>
                            <option value="GP">Guadeloupe</option>
                            <option value="GU">Guam</option>
                            <option value="GT">Guatemala</option>
                            <option value="GG">Guernsey (Kanalinsel)</option>
                            <option value="GN">Guinea</option>
                            <option value="GW">Guinea-Bissau</option>
                            <option value="GY">Guyana</option>
                          </optgroup>
                          <optgroup label="H">
                            <option value="HT">Haiti</option>
                            <option value="HM">Heard- und McDonald-Inseln</option>
                            <option value="HN">Honduras</option>
                            <option value="HK">Hongkong</option>
                          </optgroup>
                          <optgroup label="I">
                            <option value="IN">Indien</option>
                            <option value="ID">Indonesien</option>
                            <option value="IM">Insel Man</option>
                            <option value="IQ">Irak</option>
                            <option value="IR">Iran</option>
                            <option value="IE">Irland</option>
                            <option value="IS">Island</option>
                            <option value="IL">Israel</option>
                            <option value="IT">Italien</option>
                          </optgroup>
                          <optgroup label="J">
                            <option value="JM">Jamaika</option>
                            <option value="JP">Japan</option>
                            <option value="YE">Jemen</option>
                            <option value="JE">Jersey (Kanalinsel)</option>
                            <option value="JO">Jordanien</option>
                          </optgroup>
                          <optgroup label="K">
                            <option value="KY">Kaimaninseln</option>
                            <option value="KH">Kambodscha</option>
                            <option value="CM">Kamerun</option>
                            <option value="CA">Kanada</option>
                            <option value="IC">Kanarische Inseln</option>
                            <option value="CV">Kap Verde</option>
                            <option value="KZ">Kasachstan</option>
                            <option value="QA">Katar</option>
                            <option value="KE">Kenia</option>
                            <option value="KG">Kirgisistan</option>
                            <option value="KI">Kiribati</option>
                            <option value="CC">Kokosinseln</option>
                            <option value="CO">Kolumbien</option>
                            <option value="KM">Komoren</option>
                            <option value="CD">Demokratische Republik Kongo</option>
                            <option value="KP">Demokratische Volksrepublik Korea (Nordkorea)</option>
                            <option value="KR">Republik Korea (Südkorea)</option>
                            <option value="HR">Kroatien</option>
                            <option value="CU">Kuba</option>
                            <option value="KW">Kuwait</option>
                          </optgroup>
                          <optgroup label="L">
                            <option value="LA">Laos</option>
                            <option value="LS">Lesotho</option>
                            <option value="LV">Lettland</option>
                            <option value="LB">Libanon</option>
                            <option value="LR">Liberia</option>
                            <option value="LY">Libyen</option>
                            <option value="LI">Liechtenstein</option>
                            <option value="LT">Litauen</option>
                            <option value="LU">Luxemburg</option>
                          </optgroup>
                          <optgroup label="M">
                            <option value="MO">Macao</option>
                            <option value="MG">Madagaskar</option>
                            <option value="MW">Malawi</option>
                            <option value="MY">Malaysia</option>
                            <option value="MV">Malediven</option>
                            <option value="ML">Mali</option>
                            <option value="MT">Malta</option>
                            <option value="MA">Marokko</option>
                            <option value="MH">Marshallinseln</option>
                            <option value="MQ">Martinique</option>
                            <option value="MR">Mauretanien</option>
                            <option value="MU">Mauritius</option>
                            <option value="YT">Mayotte</option>
                            <option value="MK">Mazedonien</option>
                            <option value="MX">Mexiko</option>
                            <option value="FM">Mikronesien</option>
                            <option value="MD">Moldawien (Republik Moldau)</option>
                            <option value="MC">Monaco</option>
                            <option value="MN">Mongolei</option>
                            <option value="ME">Montenegro</option>
                            <option value="MS">Montserrat</option>
                            <option value="MZ">Mosambik</option>
                            <option value="MM">Myanmar (Burma)</option>
                          </optgroup>
                          <optgroup label="N">
                            <option value="NA">Namibia</option>
                            <option value="NR">Nauru</option>
                            <option value="NP">Nepal</option>
                            <option value="NC">Neukaledonien</option>
                            <option value="NZ">Neuseeland</option>
                            <option value="NI">Nicaragua</option>
                            <option value="NL">Niederlande</option>
                            <option value="AN">Niederländische Antillen</option>
                            <option value="NE">Niger</option>
                            <option value="NG">Nigeria</option>
                            <option value="NU">Niue</option>
                            <option value="MP">Nördliche Marianen</option>
                            <option value="NF">Norfolkinsel</option>
                            <option value="NO">Norwegen</option>
                          </optgroup>
                          <optgroup label="O">
                            <option value="OM">Oman</option>
                            <option value="AT">Österreich</option>
                            <option value="TL">Osttimor (Timor-Leste)</option>
                          </optgroup>
                          <optgroup label="P">
                            <option value="PK">Pakistan</option>
                            <option value="PS">Palästinensische Autonomiegebiete</option>
                            <option value="PW">Palau</option>
                            <option value="PA">Panama</option>
                            <option value="PG">Papua-Neuguinea</option>
                            <option value="PY">Paraguay</option>
                            <option value="PE">Peru</option>
                            <option value="PH">Philippinen</option>
                            <option value="PN">Pitcairninseln</option>
                            <option value="PL">Polen</option>
                            <option value="PT">Portugal</option>
                            <option value="PR">Puerto Rico</option>
                          </optgroup>
                          <optgroup label="Q"></option>
                          </optgroup>
                          <optgroup label="R">
                            <option value="TW">Republik China (Taiwan)</option>
                            <option value="CG">Republik Kongo</option>
                            <option value="RE">Réunion</option>
                            <option value="RW">Ruanda</option>
                            <option value="RO">Rumänien</option>
                            <option value="RU">Russische Föderation</option>
                          </optgroup>
                          <optgroup label="S">
                            <option value="BL">Saint-Barthélemy</option>
                            <option value="MF">Saint-Martin</option>
                            <option value="SB">Salomonen</option>
                            <option value="ZM">Sambia</option>
                            <option value="WS">Samoa</option>
                            <option value="SM">San Marino</option>
                            <option value="ST">São Tomé und Príncipe</option>
                            <option value="SA">Saudi-Arabien</option>
                            <option value="SE">Schweden</option>
                            <option value="CH">Schweiz</option>
                            <option value="SN">Senegal</option>
                            <option value="RS">Serbien</option>
                            <option value="SC">Seychellen</option>
                            <option value="SL">Sierra Leone</option>
                            <option value="ZW">Simbabwe</option>
                            <option value="SG">Singapur</option>
                            <option value="SK">Slowakei</option>
                            <option value="SI">Slowenien</option>
                            <option value="SO">Somalia</option>
                            <option value="ES">Spanien</option>
                            <option value="LK">Sri Lanka</option>
                            <option value="SH">St. Helena</option>
                            <option value="KN">St. Kitts und Nevis</option>
                            <option value="LC">St. Lucia</option>
                            <option value="PM">Saint-Pierre und Miquelon</option>
                            <option value="VC">St. Vincent und die Grenadinen</option>
                            <option value="ZA">Südafrika</option>
                            <option value="SD">Sudan</option>
                            <option value="GS">Südgeorgien und die Südlichen Sandwichinseln</option>
                            <option value="SR">Suriname</option>
                            <option value="SJ">Svalbard und Jan Mayen</option>
                            <option value="SZ">Swasiland</option>
                            <option value="SY">Syrien</option>
                          </optgroup>
                          <optgroup label="T">
                            <option value="TJ">Tadschikistan</option>
                            <option value="TZ">Tansania</option>
                            <option value="TH">Thailand</option>
                            <option value="TG">Togo</option>
                            <option value="TK">Tokelau</option>
                            <option value="TO">Tonga</option>
                            <option value="TT">Trinidad und Tobago</option>
                            <option value="TA">Tristan da Cunha</option>
                            <option value="TD">Tschad</option>
                            <option value="CZ">Tschechische Republik</option>
                            <option value="TN">Tunesien</option>
                            <option value="TR">Türkei</option>
                            <option value="TM">Turkmenistan</option>
                            <option value="TC">Turks- und Caicosinseln</option>
                            <option value="TV">Tuvalu</option>
                          </optgroup>
                          <optgroup label="U">
                            <option value="UG">Uganda</option>
                            <option value="UA">Ukraine</option>
                            <option value="HU">Ungarn</option>
                            <option value="UY">Uruguay</option>
                            <option value="UZ">Usbekistan</option>
                          </optgroup>
                          <optgroup label="V">
                            <option value="VU">Vanuatu</option>
                            <option value="VA">Vatikanstadt</option>
                            <option value="VE">Venezuela</option>
                            <option value="AE">Vereinigte Arabische Emirate</option>
                            <option value="US">Vereinigte Staaten von Amerika (USA)</option>
                            <option value="GB">Vereinigtes Königreich Großbritannien und Nordirland</option>
                            <option value="VN">Vietnam</option>
                          </optgroup>
                          <optgroup label="W">
                            <option value="WF">Wallis und Futuna</option>
                            <option value="CX">Weihnachtsinsel</option>
                            <option value="EH">Westsahara</option>
                          </optgroup>
                          <optgroup label="Z">
                            <option value="CF">Zentralafrikanische Republik</option>
                            <option value="CY">Zypern</option>
                          </optgroup>
                        </select>

                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 col-md-6">
                        <label for="inputGeburtsdatum" v-bind:class="{ 'label-error': $v.customer.birthdate.$error }">Geburtsdatum * TT.MM.JJJJ</label>
                      <input class="form-control" id="inputGeburtsdatum" placeholder="TT.MM.JJJJ" v-bind:class="{ 'is-invalid': $v.customer.birthdate.$error }" v-model="customer.birthdate">
                      <!--  <masked-input class="form-control" id="inputGeburtsdatum" mask="11.11.1111" placeholder="TT.MM.YYYY" v-bind:class="{ 'is-invalid': $v.customer.birthdate.$error }" v-model="customer.birthdate" />-->
                      </div>
                      <div class="form-group col-12 col-md-6">
                        <label for="inputTelefon">Telefon</label>
                        <input class="form-control" id="inputTelefon" placeholder="Telefon" v-model="customer.phone">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 col-md-6">
                        <label for="inputMail" v-bind:class="{ 'label-error': $v.customer.email.$error }">E-Mail Adresse *</label>
                        <input class="form-control" id="inputMail" placeholder="E-Mail Adresse" v-bind:class="{ 'is-invalid': $v.customer.email.$error }" v-model="customer.email">
                      </div>
                      <div class="form-group col-12 col-md-6">
                        <label for="inputMobil">Mobil</label>
                        <input class="form-control" id="inputMobil" placeholder="Mobil" v-model="customer.mobile">
                      </div>
                    </div>

                    <div class="row">
                      <div v-if="hasEntryLocations" class="form-group col-12 col-md-6">
                        <label for="inputZustiegsort" v-bind:class="{ 'label-error': $v.customer.entryLocation.$error }">Zustiegsort *</label>
                        <select class="form-control" id="inputZustiegsort" v-bind:class="{ 'is-invalid': $v.customer.entryLocation.$error }" v-model="customer.entryLocation" @change="onBlur">
                          <option :value="undefined" disabled>Bitte Zustiegsort auswählen</option>
                          <option v-for="loc in eventInfo.entryLocations" :value="loc">
                            {{loc}}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-12 col-md-6">
                        <label for="inputPrice" v-bind:class="{ 'label-error': $v.customer.price.$error }">Preis *</label>
                        <select class="form-control" id="inputPrice" v-bind:class="{ 'is-invalid': $v.customer.price.$error }" v-model="customer.price" @change="onBlur">
                          <option v-for="pricerow in eventInfo.prices" :value="pricerow.price" @click="setPriceCode(pricerow.code)">
                            {{pricerow.title}}, {{pricerow.price}} EUR
                          </option>
                        </select>
                      </div>

                    </div>

                  </div>
                  <div class="col-12 col-md-4 text-right">

                    <div class="text-center">
                      <h5>Ihre Buchungsübersicht</h5>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6 text-left">
                        Teilnahmegebühr
                      </div>
                      <div class="col-12 col-md-6 text-right">
                        <span v-if="customer.price">{{customer.price | stringifyNumber(',', 2)}} EUR</span>
                      </div>
                    </div>

                    <div class="row" v-for="(participant, index) in participants">
                      <div class="col-12 col-md-6 text-left">
                        {{index+2}}. Teilnehmer
                      </div>
                      <div class="col-12 col-md-6 text-right">
                        <span v-if="participant.price">{{participant.price | stringifyNumber(',', 2)}} EUR</span>
                      </div>

                    </div>

                    <hr/> Summe: <b>{{calculateTotalPrice | stringifyNumber(',', 2)}} EUR</b><br/>

                  </div>
                </div>

              </fieldset>
              <b-form-checkbox v-model="showAdditionalAddress" @click="onBlur" class="mt-3"><b>Ich möchte eine abweichende Rechnungsadresse angeben.</b></b-form-checkbox>
              <br/><br/>
              <div v-if="showAdditionalAddress" class="border-primary border-left pl-3 mb-4">

                <div class="row">
                  <div class="form-group col-12 col-md-8">
                    <label for="inputREInstitution" v-bind:class="{ 'label-error': $v.customer.invoiceaddress.company.$error }">Institution / Firmenname</label>
                    <textarea rows="2" class="form-control" id="inputREInstitution" placeholder="Institution / Firmenname" v-bind:class="{ 'is-invalid': $v.customer.invoiceaddress.company.$error }" v-model="customer.invoiceaddress.company"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12 col-md-8">
                    <label for="inputREName" v-bind:class="{ 'label-error': $v.customer.invoiceaddress.name.$error }">Ansprechpartner (Vor- und Nachname)</label>
                    <input class="form-control" id="inputREName" placeholder="Vor- und Nachname" v-bind:class="{ 'is-invalid': $v.customer.invoiceaddress.name.$error }" v-model="customer.invoiceaddress.name">
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-12 col-md-8">
                    <label for="inputREStrasse" v-bind:class="{ 'label-error': $v.customer.invoiceaddress.street.$error }">Straße und Hausnummer *</label>
                    <input class="form-control" id="inputREStrasse" placeholder="Straße und Hausnummer" v-bind:class="{ 'is-invalid': $v.customer.invoiceaddress.street.$error }" v-model="customer.invoiceaddress.street">
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-12 col-md-4">
                    <label for="inputREPLZ" v-bind:class="{ 'label-error': $v.customer.invoiceaddress.postalcode.$error }">Postleitzahl *</label>
                    <input class="form-control" id="inputREPLZ" placeholder="PLZ" v-bind:class="{ 'is-invalid': $v.customer.invoiceaddress.postalcode.$error }" v-model="customer.invoiceaddress.postalcode">
                  </div>
                  <div class="form-group col-12 col-md-4">
                    <label for="inputREOrt" v-bind:class="{ 'label-error': $v.customer.invoiceaddress.city.$error }">Ort *</label>
                    <input class="form-control" id="inputREOrt" placeholder="Ort" v-bind:class="{ 'is-invalid': $v.customer.invoiceaddress.city.$error }" v-model="customer.invoiceaddress.city">
                  </div>
                </div>
              </div>

              <b>Möchten Sie für weitere Teilnehmer buchen?</b>
              <br/><br/>
              <!--<div class="row">
              <div class="col-1">
                <button @click="removeParticipant()" class="btn btn-primary"><font-awesome-icon icon="minus"/></button>
              </div>
              <div class="col-2">
                {{participants.length}} weitere Teilnehmer
              </div>
              <div class="col-1">
                <button @click="addParticipant()" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
              </div>
            </div>

            <div class="row">
              <div class="col-3">
                <button class="btn btn-primary btn-participant" v-for="(participant, index) in participants">{{index+2}}. Teilnehmer</button>
              </div>
              <div class="col-5">
                <participant-form v-for="(participant, index) in participants" v-model="participants[index]"></participant-form>
              </div>
            </div>
            <button @click="addParticipant()" class="btn btn-primary"><font-awesome-icon icon="plus"/> Teilnehmer hinzufügen</button>
          -->
              <div class="row">
                <div class="col-12 col-md-8">

                  <div class="alert alert-danger" v-if="errorMessageForParticipantTab">
                  {{errorMessageForParticipantTab}}
                  </div>
                  <div class="alert alert-warning" v-if="lastAvailableSlotAdded">
                  Die Anmeldung weiterer Teilnehmer ist nicht möglich, da die Veranstaltung nun ausgebucht ist. Weitere Teilnehmer setzen wir gern auf die Warteliste. Kontaktieren Sie uns unter Telefon 02204 / 408472 oder schreiben Sie uns an akademie@tma-bensberg.de. Vielen Dank.
                  </div>

                  <b-card no-body>
                    <b-tabs card> <!-- :key="participant.id" -->
                      <b-tab :title="`${index+2}. Teilnehmer`" v-for="(participant, index) in participants" :key="participant.key">
                        <participant-form :k="participant.key" :validator="$v.participants.$each[index]" :prices="eventInfo.prices" :entrylocations="eventInfo.entryLocations" :jobs="eventInfo.jobs" :salutations="eventInfo.salutations" v-model="participants[index]"></participant-form>
                        <b-btn size="sm" variant="danger" class="float-right" @click="removeParticipant(index)">
                          Teilnehmer entfernen
                        </b-btn>
                      </b-tab>

                      <b-nav-item slot="tabs" @click.prevent="addParticipant()" href="#">
                        <font-awesome-icon icon="plus" /> Teilnehmer hinzufügen</b-nav-item>
                    </b-tabs>
                  </b-card>

                </div>
              </div>

            </form>
          </tab-content>
          <tab-content title="Überprüfen Sie Ihre Daten" :before-change="validateConfirmation">

            <div class="row">

              <div class="col-12 col-md-8">

                <div class="row">

                  <div class="col-12 col-md-6">

                    <h3>Ihre Daten</h3>
                    {{customer.firstname}} {{customer.lastname}}<br/>
                    {{customer.street}}<br/>
                    {{customer.postalcode}} {{customer.city}}<br/>

                    <div v-if="showAdditionalAddress">
                      <br/>
                      <b>Abweichende Rechnungsadresse:</b>
                      <div v-if="customer.invoiceaddress.company" style="white-space: pre;">{{customer.invoiceaddress.company}}</div>
                      <div v-if="customer.invoiceaddress.name">{{customer.invoiceaddress.name}}</div>
                      {{customer.invoiceaddress.street}}<br/>
                      {{customer.invoiceaddress.postalcode}} {{customer.invoiceaddress.city}}<br/>
                    </div>

                    <span v-if="customer.entryLocation"><font-awesome-icon icon="map-marker" /> {{customer.entryLocation}}<br/></span>
                    <span v-if="!customer.overnight">Keine Übernachtung</span>
                    <div v-for="discount in customer.discounts" v-if="discount">{{discount.label}}</div>

                  </div>
                  <div class="col-12 col-md-6">

                    <div v-if="customer.birthdate"><font-awesome-icon icon="birthday-cake" /> {{customer.birthdate}}</div>
                    <div v-if="customer.email"><font-awesome-icon icon="envelope" /> {{customer.email}}</div>
                    <div v-if="customer.phone"><font-awesome-icon icon="phone" /> {{customer.phone}}</div>
                    <div v-if="customer.mobile"><font-awesome-icon icon="mobile-alt" /> {{customer.mobile}}</div>

                  </div>

                </div>
                <div class="row" v-if="participants.length > 0">

                  <div class="col-12"><br/><h3>Weitere Teilnehmer</h3></div>

                    <div class="col-12 col-md-6" v-for="(participant, index) in participants">
                      <div class="card">
                        <div class="card-body">
                          {{participant.firstname}} {{participant.lastname}}<br/>
                          {{participant.street}}<br/>
                          {{participant.postalcode}} {{participant.city}}<br/>
                          <span v-if="participant.entryLocation"><font-awesome-icon icon="map-marker" /> {{participant.entryLocation}}<br/></span>
                          <span v-if="!participant.overnight">Keine Übernachtung</span>
                          <div v-for="discount in participant.discounts" v-if="discount">{{discount.label}}</div>
                        </div>
                      </div>
                    </div>

                </div>

              </div>

              <div class="col-12 col-md-4 text-right">

                <div class="text-center">
                  <h5>Ihre Buchungsübersicht</h5>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6 text-left">
                    Teilnahmegebühr
                  </div>
                  <div class="col-12 col-md-6 text-right">
                    <span v-if="customer.price">{{customer.price | stringifyNumber(',', 2)}} EUR</span>
                  </div>
                </div>

                <div class="row" v-for="(participant, index) in participants">
                  <div class="col-12 col-md-6 text-left">
                    {{index+2}}. Teilnehmer
                  </div>
                  <div class="col-12 col-md-6 text-right">
                    <span v-if="participant.price">{{participant.price | stringifyNumber(',', 2)}} EUR</span>
                  </div>

                </div>

                <hr/> Summe: <b>{{calculateTotalPrice | stringifyNumber(',', 2)}} EUR</b><br/>

              </div>
            </div>

            <br/>

            <div class="row">
              <div class="col-12 col-md-8">

                            <div class="form-group">
                              <label for="inputBemerkung">Haben Sie weitere Bemerkungen? (z.B. vegetarisches/veganes Essen; Unverträglichkeiten, ...)</label>
                              <textarea class="form-control" id="inputBemerkung" placeholder="Bemerkungen" v-model="notices" maxlength="240"></textarea>
                            </div>

              </div>
            </div>

            <b-form-checkbox v-model="termsOfService" @click="onBlur">
<span v-bind:class="{ 'label-error': $v.termsOfService.$invalid }">Ich habe die <a href="http://tma-bensberg.de/agb/" target="_blank">Allgemeinen Geschäftsbedingungen</a>, die <a href="http://tma-bensberg.de/datenschutz/" target="_blank">Datenschutzerklärung</a> sowie die <a href="https://tma-bensberg.de/reisebedingungen/" target="_blank">Reisebedingungen</a> der Thomas-Morus-Akademie Bensberg gelesen und akzeptiert. Zugleich erkenne ich diese für alle Teilnehmer an. *</span>            </b-form-checkbox>
<br/>
            <b-form-checkbox v-model="acceptNewsletter" @click="onBlur">Bitte senden Sie mir zukünftig regelmäßig Informationen per E-Mail zu. Mit dem Newsletter-Versand an die angegebene E-Mail-Adresse sowie der Erhebung, Verarbeitung und Nutzung meiner Daten gemäß der  <a href="http://tma-bensberg.de/datenschutz/" target="_blank">Datenschutzerklärung</a> bin ich einverstanden. Mir ist bekannt, dass ich der künftigen Zusendung jederzeit formlos durch die Zusendung einer E-Mail an akademie@tma-bensberg.de widersprechen kann.</b-form-checkbox>

          </tab-content>
          <tab-content title="Zahlungsinformationen">
            <div class="alert alert-secondary">Sofern Sie Probleme bei der Zahlung mit Ihrer Kreditkarte haben, prüfen Sie bitte zuerst, ob Sie diese bereits bei Ihrer Bank / Sparkasse für das 3-D Secure Verfahren freigeschaltet haben, welches jetzt verpflichtend für sämtliche Zahlungen mit der Kreditkarte im Internet ist.</div>
            <payment-form :paymentMethods="pMethods" :customer="customer" :eventInfo="eventInfo" :participants="participants"></payment-form>
          </tab-content>
          <tab-content title="Bestätigung">
          </tab-content>

          <template slot="footer" scope="props">
            <div class=wizard-footer-left>
              <wizard-button v-if="props.activeTabIndex == 2" @click.native="onPreviousStep(props.activeTabIndex)" :style="props.fillButtonStyle">Zum vorigen Schritt</wizard-button>
              <wizard-button v-if="props.activeTabIndex > 0 && props.activeTabIndex != 2" @click.native="props.prevTab()" :style="props.fillButtonStyle">Zum vorigen Schritt</wizard-button>
            </div>
            <div class="wizard-footer-right">
              <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Zum nächsten Schritt</wizard-button>
            </div>

          </template>

          <template slot="step" scope="props">
                  <wizard-step :tab="props.tab"
                  :transition="props.transition"
                  :key="props.tab.title"
                  :index="props.index"
                  style="cursor: default">
                  </wizard-step>
                </template>

        </form-wizard>
      </div>
    </div>
  </div>
</div>
</template>

<style lang="scss">
.event-header {
    width: 100%;
    position: relative;
}

.event-header .bg-thumb {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.event-header .event-header-inner {
    background-color: rgba(255,255,255,0.85);
    position: relative;
    width: 100%;
    height: 100%;
    padding: 50px;
}

.logo {
    float: right;
    width: 160px;
}

.event-body {
    padding: 50px;
}

.enrollment {
    padding: 50px !important;
}

.enrollment-header {
    border-bottom: 1px solid #DDD;
    padding-bottom: 30px;
    margin-bottom: 0;
}

.btn-participant {
    margin-bottom: 1px;
}

label .label-error a {
  text-decoration:underline !important;
  color:#FFF;
}

label .label-error a:hover {
  color:#FFF;
}

ul.wizard-nav.wizard-nav-pills li a:hover {
  cursor: default !important;
}

.btn-primary,
.wizard-btn,
.wizard-btn [style]{
  background-color:#1e1584 !important;
  border-color:#000 !important;
}

.stepTitle,
.stepTitle [style] {
  color:#000 !important;
}
.wizard-icon,
.wizard-icon [style] {
   color:#000 !important;
 }
</style>

<script>
import Vue from 'vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import VRPayPaymentForm from './../components/VRPayPaymentForm.vue'
import PartipantForm from './../components/Participant.vue'
import Loader from  './../components/loader.vue'
import API from '@/lib/api'
import {
  FormWizard,
  TabContent,
  WizardButton,
  WizardStep
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { required, requiredIf, email, helpers, not, sameAs} from 'vuelidate/lib/validators'
import VueScript2 from 'vue-script2'
import MaskedInput from 'vue-masked-input'
import moment from 'moment'
moment.locale('de');
const validatorDate = (value) => {
  if(!value) return false
  value = value.replace(/\s/g, "");
  return helpers.regex('isGermanDate', /^([0]?[1-9]|[1|2][0-9]|[3][0|1])[.]([0]?[1-9]|[1][0-2])[.]([0-9]{4}|[0-9]{2})$/gm)(value)
}
const checked = sameAs(() => true)

export default {
  name: 'home',
  components: {
    FontAwesomeIcon,
    'payment-form': VRPayPaymentForm,
    'participant-form': PartipantForm,
    FormWizard,
    TabContent,
    WizardButton,
    WizardStep,
    MaskedInput,
      Loader
  },
  data() {
    return {
      componentReady: false,
      formWizardStartStep: 0,
      nextParticipantKey: 0,
      eventInfo: {
        salutation: [],
        jobs: []
      },
      lastAvailableSlotAdded: false,
      pMethods: {
        'debit': {
          brands: ['DIRECTDEBIT_SEPA'],
          title: 'SEPA-Lastschrift'
        },
        'creditcard': {
          brands: ['VISA', 'MASTER'],
          title: 'Kreditkarte'
        }
      },
      customer: {
        overnight: true,
        discounts: [],
        country:'DE',
        price: null,
        pricecode: null,
        invoiceaddress: {}
      },
      participants: [],
      termsOfService: false,
      acceptNewsletter: false,
      notices: '',
      vrpay_widget_url: process.env.VUE_APP_VRPAY_WIDGET_URL,
      showAdditionalAddress: false
    }
  },
  validations: {
    customer: {
      firstname: { required },
      lastname: { required },
      street: { required },
      postalcode: { required },
      city: { required },
      birthdate: { required, validatorDate },
      email : { required, email },
      entryLocation: { required: requiredIf(function () {
        if(!this.eventInfo.entryLocations.length ) return false
        return true
      }) },
      country: { required },
      price: { required },
      job: {},
      salutation: {},
      invoiceaddress: {
        name: {
        },
        company: {
        },
        street: {
          required: requiredIf(function () { return this.showAdditionalAddress })
        },
        postalcode: {
          required: requiredIf(function () { return this.showAdditionalAddress })
        },
        city: {
          required: requiredIf(function () { return this.showAdditionalAddress })
        }
      }
    },
    termsOfService: { checked },
    participants: {
      $each: {
          job: {},
          salutation: {},
          firstname: { required },
          lastname: { required },
          street: { required },
          postalcode: { required },
          price: { required },
          city: { required },
          entryLocation: { required: requiredIf(function () {
            if(!this.eventInfo.entryLocations.length ) return false
            return true
          }) }
      }
    }
  },
  watch: {
    showAdditionalAddress(val) {
      if(!val && this.customer) {
        this.customer.invoiceaddress = {}
      }
    }
  },
  computed: {
    isEventDateAfterSept23() {
      if(this.eventInfo) {
        return moment(this.eventInfo.startDate).isSameOrAfter("2023-09-01")
      }
      return false
    },
    hasDiscounts() {
      if(!this.eventInfo.discounts) return false
      return (this.eventInfo.discounts.length > 0)
    },
    hasEntryLocations() {
      if(!this.eventInfo.postId) return false
      return !(this.eventInfo.entryLocations.length == 0)
    },
    eventDateTime() {
      let momStart = moment(this.eventInfo.startDate);
      let momEnd = moment(this.eventInfo.endDate);

      if (momEnd.isAfter(momStart, 'day')) {
        if (momEnd.isSame(momStart, 'month')) {
          return `${momStart.format('D.')} bis ${momEnd.format('D. MMMM Y')} (${momStart.format('dd.')}-${momEnd.format('dd.')})`
        } else {
          return `${momStart.format('D. MMMM')} bis ${momEnd.format('D. MMMM Y')} (${momStart.format('dd.')}-${momEnd.format('dd.')})`
        }
      } else {
        return `${momStart.format('D. MMMM Y')} (${momStart.format('dd.')})`
      }
    },
    calculateTotalPrice() {

      let price = this.customer.price ? this.customer.price : 0
      for (let i = 0; i < this.participants.length; i++) {
          price += this.participants[i].price ? this.participants[i].price : 0
      }
      return price;

    },
    errorMessageForParticipantTab() {
      if(this.$v.participants == undefined) return false;

      if(this.$v.participants.$dirty && this.$v.participants.$invalid) {

            var errNumParticipants = [];
            for(var i in this.$v.participants.$each.$iter) {

              if(this.$v.participants.$each[i].$invalid) {
                errNumParticipants.push(parseInt(i)+2);
              }

            }

            return "Bitte überprüfen Sie die rot markierten Felder im "+ errNumParticipants.join(". und ") +". Teilnehmer, vielen Dank!";

        }

        return false;
    }
  },
  beforeMount() {

    if(this.$router.currentRoute.query.payment == "failed") {
      if(sessionStorage.getItem('customer')) this.customer = JSON.parse(sessionStorage.getItem('customer'));
      if(sessionStorage.getItem('participants')) this.participants = JSON.parse(sessionStorage.getItem('participants'));
      if(sessionStorage.getItem('notices')) this.notices = JSON.parse(sessionStorage.getItem('notices'));
      if(sessionStorage.getItem('acceptNewsletter')) this.acceptNewsletter = JSON.parse(sessionStorage.getItem('acceptNewsletter'));
      if(sessionStorage.getItem('showAdditionalAddress')) this.showAdditionalAddress = JSON.parse(sessionStorage.getItem('showAdditionalAddress'));

      if(sessionStorage.getItem('customer')) {
        this.formWizardStartStep = 1;
        alert("Ihre Zahlungsinformationen waren leider ungültig. Sie können es gerne erneut versuchen. Bei Problemen schreiben Sie uns an akademie@tma-bensberg.de oder rufen Sie uns an: 02204 / 408472 ");
      }
    }

    if(this.$router.currentRoute.query.step == 1) {
      console.log("####", sessionStorage.getItem('customer'))
      if(sessionStorage.getItem('customer')) this.customer = JSON.parse(sessionStorage.getItem('customer'));
      if(sessionStorage.getItem('participants')) this.participants = JSON.parse(sessionStorage.getItem('participants'));
      if(sessionStorage.getItem('notices')) this.notices = JSON.parse(sessionStorage.getItem('notices'));
      if(sessionStorage.getItem('acceptNewsletter')) this.acceptNewsletter = JSON.parse(sessionStorage.getItem('acceptNewsletter'));
      if(sessionStorage.getItem('showAdditionalAddress')) this.showAdditionalAddress = JSON.parse(sessionStorage.getItem('showAdditionalAddress'));

      if(sessionStorage.getItem('customer')) {
        this.formWizardStartStep = 1;
      }
    }

  },
  async mounted() {

    let result
    try{
      result = await API.get('/events/' + this.$route.params.postId)

       if(result.data.$availableSlots <= 0) {
          this.$router.push('/booked-up')
           return
       }
      this.eventInfo = result.data;
      this.componentReady = true
      if(this.eventInfo.prices && this.eventInfo.prices.length > 0) {
       setTimeout(() => {
         this.customer.price = this.eventInfo.prices[0].price
         this.customer.pricecode = this.eventInfo.prices[0].code

       }, 1000)
      }



    }catch(e){
      window.location.assign(process.env.VUE_APP_ERROR_REDIRECT_URL)
    }

  },
  methods: {
    onPreviousStep(activeIndex) {
      let prevStep = activeIndex-1;
      let newLocation = location.href.split('?')[0] + '?step=' + prevStep

      location.assign(newLocation)
      location.reload()
    },
    onTabChange(prevIndex, nextIndex) {
      if(nextIndex == 2) {
        document.getElementsByClassName("wizard-footer-right")[0].style.display = 'none';
      }
      else {
        document.getElementsByClassName("wizard-footer-right")[0].style.display = 'block';
      }
    },
    validateEnrollmentInfo() {
      return new Promise(async (resolve, reject) => {
        let isInvalid = false
        if (this.$v.customer.$invalid) {
          this.$v.customer.$touch();
          isInvalid = true
        }
        if (this.$v.participants.$invalid) {
          this.$v.participants.$touch()
          isInvalid = true
        }
        if(isInvalid) {
          reject()
          return
        }

        resolve(true)
      })
    },
    validateConfirmation() {
      document.getElementsByClassName("wizard-footer-right")[0].style.display = 'true';

      return new Promise ( async (resolve, reject) => {
        if(this.$v.termsOfService.$invalid){
          reject()
          return
        }

        let result = await API.get('/events/' + this.$route.params.postId)
        if(result.data.$availableSlots < (this.participants.length + 1)) {
            //notify user about too few slots in event
            alert("Inzwischen ist die Veranstaltung ausgebucht. Gern nehmen wir Sie in die Warteliste auf oder informieren Sie über ähnliche Veranstaltungen. Schreiben Sie uns an akademie@tma-bensberg.de oder rufen Sie uns an: 02204 / 408472");
            reject()
            return
        }

        let res
        //generate checkout-id from vr-pay
        try{

          sessionStorage.setItem('customer', JSON.stringify(this.customer));
          sessionStorage.setItem('participants', JSON.stringify(this.participants));
          sessionStorage.setItem('notices', JSON.stringify(this.notices));
          sessionStorage.setItem('acceptNewsletter', JSON.stringify(this.acceptNewsletter));
          sessionStorage.setItem('showAdditionalAddress', JSON.stringify(this.showAdditionalAddress));

            res = await API.post('/enrollments', {
                customer: this.customer,
                participants: this.participants,
                vno: this.eventInfo.vno,
                postId: this.eventInfo.postId,
                notices: this.notices,
                termsOfService: this.termsOfService,
                newsletter: this.acceptNewsletter
            })
        }catch(e) {

            if(e.response.data === 'invalid prices') {
              alert("In der Zwischenzeit haben sich unsere Preise verändert, wahrscheinlich ist die Frist für einen Frühbucherpreis abgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie uns an akademie@tma-bensberg.de oder rufen Sie uns an: 02204 / 408472")
              location.assign(location.href.split('?')[0] + '?step=0')
              location.reload()
            }
            else {
              //Too few slots reported from server!
              alert("Es trat leider ein Fehler auf. Schreiben Sie uns an akademie@tma-bensberg.de oder rufen Sie uns an: 02204 / 408472");
            }
            reject()
            return
        }

        await VueScript2.load(this.vrpay_widget_url + '?checkoutId=' + res.data.token).then(() => {
          console.log("Payframe requested")
        })
        window.tc = res.data.token;

        resolve(true)
      })
    },
    handleValidation(isValid, tabIndex) {
      console.log(isValid, tabIndex)
    },
    addParticipant() {
      if(this.eventInfo.$availableSlots == (this.participants.length + 2) ){
        this.lastAvailableSlotAdded = true;
      }
      if(this.eventInfo.$availableSlots <= (this.participants.length + 1)){
        alert("Leider haben wir keine offenen Plätze für weitere Teilnehmer. Schreiben Sie uns an akademie@tma-bensberg.de oder rufen Sie uns an: 02204 / 408472");
        return;
      }

      this.participants.push({overnight: true, discounts: [], key: 'key' + this.nextParticipantKey });
      this.nextParticipantKey++;
    },
    removeParticipant(index) {
      this.participants.splice(index, 1);
      this.lastAvailableSlotAdded = false;
    },
    onBlur() {
      this.$emit('input', this.form)
    },
    setPriceCode(code) {
      this.customer.pricecode = code
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue